import { supabase } from '../supabase';

/** CRM app setting key: master toggle for lead custom fields. Off by default. */
export const CUSTOM_FIELDS_ENABLED_KEY = 'custom_fields_enabled';

/** Fired whenever definitions change so open CRM views can reload them. */
export const CUSTOM_FIELDS_CHANGED_EVENT = 'crmCustomFieldsChanged';

export type CustomFieldType = 'text' | 'number' | 'dropdown' | 'textarea' | 'date';

export interface CustomFieldOptions {
  /** dropdown: preset choices */
  choices?: string[];
  /** dropdown: show a "Custom…" entry that reveals a free-text input */
  allowCustom?: boolean;
  /** number: pick-list range */
  min?: number;
  max?: number;
}

export interface CustomFieldDefinition {
  id: string;
  name: string;
  type: CustomFieldType;
  required: boolean;
  displayOrder: number;
  options: CustomFieldOptions | null;
}

export async function fetchCustomFieldDefinitions(businessId: string): Promise<CustomFieldDefinition[]> {
  const { data, error } = await supabase
    .from('opportunity_custom_fields')
    .select('id, field_name, field_type, is_required, display_order, options')
    .eq('business_id', businessId)
    .order('display_order', { ascending: true });
  if (error) throw error;
  return (data || []).map((f) => ({
    id: f.id,
    name: f.field_name,
    type: (f.field_type || 'text') as CustomFieldType,
    required: f.is_required === true,
    displayOrder: f.display_order ?? 0,
    options: (f.options as CustomFieldOptions | null) || null,
  }));
}

export function notifyCustomFieldsChanged() {
  window.dispatchEvent(new CustomEvent(CUSTOM_FIELDS_CHANGED_EVENT));
}
